import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e6fdf8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header border-0 pt-5 pb-3" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 text-primary px-3 py-1 rounded" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "text-muted fs-6 me-4"
}
const _hoisted_7 = { class: "dropdown" }
const _hoisted_8 = {
  class: "btn btn-sm btn-color-muted btn-active btn-active-light-primary dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_11 = { class: "card-body pt-2 pb-5" }
const _hoisted_12 = {
  key: 0,
  class: "py-5"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-header" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-line" }, null, -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "section-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-title" }, "Published Ads")
], -1))
const _hoisted_19 = { class: "row-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "Regular")
], -1))
const _hoisted_21 = { class: "metrics-grid" }
const _hoisted_22 = { class: "metric-label" }
const _hoisted_23 = { class: "metric-value" }
const _hoisted_24 = { class: "row-group" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-info" }, "Featured")
], -1))
const _hoisted_26 = { class: "metrics-grid" }
const _hoisted_27 = { class: "metric-label" }
const _hoisted_28 = { class: "metric-value" }
const _hoisted_29 = { class: "section-group mt-5 active-ads-section" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-title" }, "Active Ads"),
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-warning fs-8 fw-semibold" }, "Not affected by filters")
], -1))
const _hoisted_31 = { class: "row-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-success" }, "Regular")
], -1))
const _hoisted_33 = { class: "metrics-grid" }
const _hoisted_34 = { class: "metric-label" }
const _hoisted_35 = { class: "metric-value" }
const _hoisted_36 = { class: "row-group" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Featured")
], -1))
const _hoisted_38 = { class: "metrics-grid" }
const _hoisted_39 = { class: "metric-label" }
const _hoisted_40 = { class: "metric-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDatePicker = _resolveComponent("CustomDatePicker")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.translate('adsBreakdown')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.selectedPeriod === 'custom')
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(`${_ctx.customDateFrom} till ${_ctx.customDateTo}`), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", _hoisted_8, _toDisplayString(_ctx.selectedPeriod), 1),
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectPeriod('yesterday')), ["prevent"]))
                }, _toDisplayString(_ctx.translate('yesterday')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectPeriod('last-7-days')), ["prevent"]))
                }, _toDisplayString(_ctx.translate('last7Days')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectPeriod('last-30-days')), ["prevent"]))
                }, _toDisplayString(_ctx.translate('last30Days')), 1)
              ]),
              _hoisted_10,
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showCustomDatePicker()), ["prevent"]))
                }, _toDisplayString(_ctx.translate('customRange')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_CustomDatePicker, {
        show: _ctx.showDatePicker,
        dateFrom: _ctx.customDateFrom,
        "onUpdate:dateFrom": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customDateFrom) = $event)),
        dateTo: _ctx.customDateTo,
        "onUpdate:dateTo": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customDateTo) = $event)),
        onApply: _ctx.applyCustomDates,
        onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDatePicker = false))
      }, null, 8, ["show", "dateFrom", "dateTo", "onApply"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.loadingPublished)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
        : _createCommentVNode("", true),
      (!_ctx.loadingPublished)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionTypes, (type) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `entered-regular-${type.key}`,
                      class: "metric-card entered-regular"
                    }, [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(type.label), 1),
                      _createElementVNode("div", _hoisted_23, _toDisplayString((_ctx.enteredAdsSection.regular[type.key] || 0).toLocaleString()), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionTypes, (type) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `entered-special-${type.key}`,
                      class: "metric-card entered-special"
                    }, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(type.label), 1),
                      _createElementVNode("div", _hoisted_28, _toDisplayString((_ctx.enteredAdsSection.special[type.key] || 0).toLocaleString()), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionTypes, (type) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `active-regular-${type.key}`,
                class: "metric-card active-regular"
              }, [
                _createElementVNode("div", _hoisted_34, _toDisplayString(type.label), 1),
                _createElementVNode("div", _hoisted_35, _toDisplayString((_ctx.activeAdsSection.regular[type.key] || 0).toLocaleString()), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionTypes, (type) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `active-special-${type.key}`,
                class: "metric-card active-special"
              }, [
                _createElementVNode("div", _hoisted_39, _toDisplayString(type.label), 1),
                _createElementVNode("div", _hoisted_40, _toDisplayString((_ctx.activeAdsSection.special[type.key] || 0).toLocaleString()), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}